import { signal } from "@preact/signals-react"

import { DATE_PERIODS } from "@constants"

export const shareOfSearchKpiIsEmpty = signal(false)
export const shareOfSearchKpiDetailsFilters = signal({})

export const shareOfSearchKpiEvolutionFilters = signal({})
export const shareOfSearchKpiEvolutionDatePeriod = signal(DATE_PERIODS.LAST_7_DAYS)
export const shareOfSearchKpiEvolutionKeywordsOptions = signal({})
export const shareOfSearchKpiEvolutionCurrentPeriod = signal("")
export const shareOfSearchKpiEndDate = signal("")


// Functions
export const resetShareOfSearchKpiSignals = () => {
	shareOfSearchKpiIsEmpty.value = false
	shareOfSearchKpiDetailsFilters.value = {}
	shareOfSearchKpiEvolutionFilters.value = {}
	shareOfSearchKpiEvolutionDatePeriod.value = DATE_PERIODS.LAST_7_DAYS
	shareOfSearchKpiEvolutionKeywordsOptions.value = {}
}